import styled from "@emotion/styled";

export const Styled = styled.div`
  * {
    border-color: black;
  }
  table,
  th,
  td {
    border: 1px solid black;
  }

  table {
    border-width: 2px;
  }
  td {
    min-height: 5mm;
  }

  table {
    border-collapse: collapse;
  }
`;
